var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
    color: '',
  })},[_c('app-bar'),_c('side-bar'),_c('base-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }